import { brandingValues as RIA } from './ria';
import { brandingValues as Walmart } from './walmart';
import { brandingValues as MirandaEnvios } from './miranda';
import { brandingValues as Viva } from './viva';

export const brandings = {
  RIA,
  Walmart,
  MirandaEnvios,
  Viva
};

let buildInitBranding = brandings.RIA;
let buildBranding = '__buildBranding' // on purpose not existing so it can be filled by the build
for (const branding in brandings) {
  if (buildBranding === branding) {
    buildInitBranding = brandings[branding];
    break;
  }
}

export const initBranding = buildInitBranding;


// WEBPACK FOOTER //
// ./src/environment/branding/brandings.ts